export default __webpack_public_path__ + "static/media/about2.0a1a4666.png";